import React from 'react';
import PropTypes from 'prop-types';

import {
  TextField,
  Button,
} from '@material-ui/core';

import { Wrapper } from './Editor.styles';

class Editor extends React.Component {
  state = {}

  onSend = () => {
    const { onSend } = this.props;
    onSend();
  }

  render() {
    const {
      action,
      data: {
        name,
      },
      set,
      onClose,
    } = this.props;

    return (
      <Wrapper>
        <div className="columns is-bottom-aligned">
          <div className="column is-3">
            <TextField
              label="Nombre"
              fullWidth
              value={name}
              onChange={e => set('name', e.target.value)}
            />
          </div>
          <div className="column is-2 form-actions">
            {
              action === 'edit' ? (
                <Button color="primary" onClick={this.onSend}>Guardar</Button>
              ) : (
                <Button color="secondary" onClick={this.onSend}>Crear</Button>
              )
            }
            <Button className="close-button" onClick={onClose}>X</Button>
          </div>
        </div>
      </Wrapper>
    );
  }
}

Editor.propTypes = {
  action: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  set: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Editor;
